export function addCurrent(llm) {
  return {
    type: 'ADD_CURRENT',
    llm,
  }
}
